module.exports = __webpack_public_path__ + "static/media/white_left_arrow_icon.bee21589.svg";